import { trigger, transition, style, animate, query, stagger } from "@angular/animations";

const defaultEnter = "0.3s ease-out";
const defaultLeave = "0.3s ease-in";
const defaultStagger = 50;

//Base helper for single animation
function createFadeSlide(dir: "X" | "Y", from: number) {
    return [
        transition(":enter", [
            style({ opacity: 0, [`transform`]: `translate${dir}(${from}px)` }),
            animate(defaultEnter, style({ opacity: 1, transform: "translate(0)" })),
        ]),
        transition(":leave", [
            animate(defaultLeave, style({ opacity: 0, [`transform`]: `translate${dir}(${from * -1}px)` })),
        ]),
    ];
}

//Base helper for stagger animation
function createFadeSlideStagger(dir: "X" | "Y", from: number) {
    return [
        transition(":enter", [
            query(
                ":scope > *",
                [
                    style({ opacity: 0, transform: `translate${dir}(${from}px)` }),
                    stagger(defaultStagger, [animate(defaultEnter, style({ opacity: 1, transform: "translate(0)" }))]),
                ],
                { optional: true }
            ),
        ]),
    ];
}

//Single Element Animations
export const fadeSlideInLeft = trigger("fadeSlideInLeft", createFadeSlide("X", -20));
export const fadeSlideInRight = trigger("fadeSlideInRight", createFadeSlide("X", 20));
export const fadeSlideInUp = trigger("fadeSlideInUp", createFadeSlide("Y", 20));
export const fadeSlideInDown = trigger("fadeSlideInDown", createFadeSlide("Y", -20));

//Staggered Child Animations
export const fadeSlideInLeftStagger = trigger("fadeSlideInLeftStagger", createFadeSlideStagger("X", -20));
export const fadeSlideInRightStagger = trigger("fadeSlideInRightStagger", createFadeSlideStagger("X", 20));
export const fadeSlideInUpStagger = trigger("fadeSlideInUpStagger", createFadeSlideStagger("Y", 20));
export const fadeSlideInDownStagger = trigger("fadeSlideInDownStagger", createFadeSlideStagger("Y", -20));
